module.exports = __webpack_public_path__ + "img/3.6d76cfd8.png";